var s = /* @__PURE__ */ ((e) => (e[e.header = 0] = "header", e[e.body = 1] = "body", e))(s || {});
function c(e, t) {
  if (!e)
    return null;
  const r = e.split(".");
  if (r.length !== 3)
    return null;
  const n = r[
    t ?? 1
    /* body */
  ].replace(/-/g, "+").replace(/_/g, "/"), o = decodeURIComponent(
    atob(n).split("").map((l) => "%" + ("00" + l.charCodeAt(0).toString(16)).slice(-2)).join("")
  );
  return JSON.parse(o);
}
export {
  s as TokenPart,
  c as jwtDecoder
};
